import {
  ProgressRoot as ChakraProgressRoot,
  ProgressTrack,
  ProgressRange,
} from "@chakra-ui/react";
import { forwardRef } from "react";

type ProgressProps = {
  value?: number; // v1/v2 backward compatibility
  "aria-label"?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
};

const Progress = forwardRef<HTMLDivElement, ProgressProps>(
  ({ value, ...props }, ref) => {
    return (
      <ChakraProgressRoot
        ref={ref}
        value={value}
        css={{
          backgroundColor: "gray.400",
          "& [role='progressbar']": {
            backgroundColor: "primary.800",
            backgroundImage:
              "linear-gradient(to right, transparent 0%, var(--chakra-colors-primary-800) 50%, transparent 100%)",
          },
        }}
        {...props}
      >
        <ProgressTrack>
          <ProgressRange />
        </ProgressTrack>
      </ChakraProgressRoot>
    );
  }
);

Progress.displayName = "Progress";

export default Progress;
